import { z } from 'zod/v4';

import { BomItemsRuntype } from '../assembly';
import { QuantityRuntype } from '../backendTypes';
import { DesignItemResponseDTONewRuntype } from '../designItem';
import { endpoint } from '../http/endpoint';
import { AssemblyIdRuntype } from '../idTypes';
import { AddPartEventsRuntype, PartSpecificationRuntype } from '../part';
import { PartSuggestionFullRuntype } from './bomItemBackendTypes';

export const bomItemEndpoints = {
    'GET /bom-items/:aggregationKey/suggestions': endpoint({
        description: 'Fetches a list of suggestions for a given bomItem',
        pathParams: z.object({ aggregationKey: z.string() }),
        queryParams: z.object({ assembly_id: AssemblyIdRuntype, max_components: z.number().optional() }),
        requestBody: z.undefined(),
        responseBody: z.object({
            items: z.array(PartSuggestionFullRuntype),
        }),
    }),
    'PATCH /bom-items/:aggregationKey': endpoint({
        description:
            'Updates the given design items of the BOM item identified by the aggregation key. All the IDs must belong to that BOM item.',
        pathParams: z.object({ aggregationKey: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.object({
            do_not_place: z.boolean().optional(),
            ids: z.array(z.string()),
            notes: z.string().optional(),
            part_specification: PartSpecificationRuntype.nullable(),
            quantity: z.union([QuantityRuntype, z.null()]).optional(),
            is_consigned: z.boolean().optional(),
            ignore_package_name_mismatch: z.boolean().optional(),
            add_part_events: z.array(AddPartEventsRuntype),
        }),
        responseBody: z.object({
            items: z.array(z.string()),
        }),
    }),
    'POST /bom-items/:aggregationKey/design-items/bulk-delete': endpoint({
        description: `Deletes the given design items from the BOM item identified by the aggregation key. All the IDs must belong to that BOM item.
        We are using a POST request instead of delete because the list of IDs
        can be very long in the query parameters and we don't want to hit the URL limit. If the URL is too long, the request won't be sent out by the browser.`,
        pathParams: z.object({ aggregationKey: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.object({
            ids: z.array(z.string()),
        }),
        responseBody: z.object({
            deleted: z.number(),
        }),
        invalidates: [
            'GET /assemblies/:assemblyId/descendants',
            'GET /assemblies/:assemblyId/descendants-summary',
            'GET /assemblies/:id/history',
        ],
    }),
    'GET /bom-items/:aggregationKey': endpoint({
        description: 'Fetches the BOM Item with its design-items',
        pathParams: z.object({ aggregationKey: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({
            data: z.object({
                bom_item: BomItemsRuntype,
                design_items: z.array(DesignItemResponseDTONewRuntype),
            }),
        }),
    }),
};
